jQuery(document).ready(function($) {
  if ($('body').hasClass('admin_videos')) {
    $('.batch_action').each(function() {
        $(this).on('click', function(){
          $('select[name="program"]').first().select2({
            width: '80%',
            dropdownParent: $("[role=dialog]").first()
          })
          $('select[name="collection"]').first().select2({
            width: '80%',
            dropdownParent: $("[role=dialog]").first()
          })
        })
    });
  }
})
